<!-- Container div replaces <div id="app"></div> -->
<!-- <div #app class="molstar-container" aria-label="Embedded Mol* Viewer"></div> -->
<div class="molstar-panel">

  <div #app class="molstar-container" id="molstarA"></div>
</div>
{{title}}